import $ from 'jquery';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import useApiUrl from '../../framework/hooks/useApiUrlHook';
import TeamItem from "./TeamItem";
import TeamSwiperItem from "./TeamSwiperItem";
import TeamWrapper from "./TeamWrapper";
import aos from "../scripts/AOS";
import {initAOS} from "../../Helpers";

export default function TeamSlider({ all = false }) {
    const apiUrl = useApiUrl();
    const [team, setTeam] = useState([]);

    useEffect(() => {
        $('.team-wrap').mouseenter(function () {
            $(this).addClass('active');
            $(this).siblings().removeClass('active');
        });

        initAOS();
    }, [team]);

    const getTeam = () => {
        axios
            .get(all === true ? `${apiUrl}/team/all` : `${apiUrl}/team/home`)
            .then((response) => {
                setTeam(response.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (apiUrl != null) getTeam();
    }, [apiUrl]);

    return (
        <div className="team-area sections section-b">
            <div className="team-heading" data-aos="fade-up" data-aos-duration={1000}>
                <h2>Kom samenwerken met</h2>
                <h3>Onze creatievelingen</h3>
            </div>
            {team?.chunks?.map((members, index) => (
                <TeamWrapper
                    key={index}
                    itemKey={index}
                    first={index === 0}
                    showAllButton={!all}
                    teamMembers={members}
                    allTeamMembers={team.all}
                />
            ))}
        </div>
    );
}
